/**
 * SIDEBAR TOKENS
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createSidebarTokens(s: SemanticTokens) {
  return {
    bgDefault: v('sidebar.item.bg-default'), // --sidebar-item-bg-default: var(--surface-ground)
    bgHover: v('sidebar.item.bg-hover'), // --sidebar-item-bg-hover: var(--color-rentals-50)
    bgActive: v('sidebar.item.bg-active'), // --sidebar-item-bg-active: var(--color-rentals-50)
    bgDisabled: s.surface.disabled, // --sidebar-item-bg-disabled: var(--surface-disabled)
    fgDefault: v('sidebar.item.fg-default'), // --sidebar-item-fg-default: var(--text-secondary)
    fgHover: s.text.secondary, // --sidebar-item-fg-hover: var(--text-secondary)
    fgActive: v('sidebar.item.fg-active'), // --sidebar-item-fg-active: var(--text-primary)
  };
}
export const sidebarTokens = createSidebarTokens(SEMANTIC);
